import SpraySessionEntriesService from '../../services/v2/SpraySessionsService';
import SprayRequestsService from '../../services/v2/SprayRequestsService';

import NoSprayService from '../../services/NoSprayService';
import AdulticideService from '../../services/AdulticideService';
import AdultAppRatesService from '../../services/AdultAppRatesService';

import Mappable from './mappable';
import moment from 'moment';

export default class extends Mappable {
  constructor(json) {
    super(json.id, json.name || 'Adulticide', json.coordinates);
    this.id = json.id;
    this.date = moment(json.date);
    this.startedAt = moment(json.startedAt);
    this.endedAt = moment(json.endedAt);
    this.zone = json.zone;
    this.site = json.site;
    this.contract = json.contract;
    this.chemical = json.chemical;
    this.applicator = json.applicator;
    this.truck = json.truck;
    this.onSelectedChanged = () => null;
    const copy = { ...this };
    Object.assign(this, json, copy);
  }

  get mappableType() {
    return 'Adulticide';
  }

  get zoneId() {
    return this.dig(this.zone, 'id');
  }

  get zoneName() {
    return this.dig(this.zone, 'name', 'N/A');
  }

  get siteId() {
    return this.dig(this.site, 'id');
  }

  get siteName() {
    return this.dig(this.site, 'name', 'N/A');
  }

  get contractName() {
    return this.dig(this.contract, 'name', 'N/A');
  }

  get chemicalId() {
    return this.dig(this.chemical, 'id');
  }

  get chemicalName() {
    return this.dig(this.chemical, 'name', 'N/A');
  }

  get applicatorId() {
    return this.dig(this.applicator, 'id');
  }

  get applicatorName() {
    return this.dig(this.applicator, 'name', 'N/A');
  }

  get truckId() {
    return this.dig(this.truck, 'id');
  }

  get truckName() {
    return this.dig(this.truck, 'name', 'N/A');
  }

  get pinSrc() {
    return require('@/assets/img/map/pin-adulticide-active.svg');
  }

  get badgeSrc() {
    return require('@/assets/img/map/badge-adulticide-active.svg');
  }

  requestSpraySessionEntries(callback) {
    if (this.spraySessionEntries) {
      return callback(this.spraySessionEntries);
    }

    const $this = this;
    const { id } = $this;
    const makeRequest = async () => {
      let { spraySessionEntries } = await SpraySessionEntriesService.index({
        adulticideId: id,
      });
      spraySessionEntries.sort((a, b) => {
        return a.timestamp.localeCompare(b.timestamp)
      })
      $this.spraySessionEntriesTotal = spraySessionEntries.length;
      $this.spraySessionEntries = spraySessionEntries;
      callback(spraySessionEntries);
    };
    makeRequest();
  }

  requestApplicationRate(callback) {
    if (this.applicationRate) {
      return callback(this.applicationRate);
    }
    const $this = this;
    const { adultapprateId } = $this;
    const makeRequest = async () => {
      AdultAppRatesService.getList().then(({ data }) => {
        const matchingAppRate = data[0];
        const applicationRate = matchingAppRate.attributes.apprate;
        callback(applicationRate);
        $this.applicationRate = applicationRate;
      });
    };

    makeRequest();
  }

  requestNoSprayEntries(callback) {
    const { contractId } = this.site;
    const makeRequest = async () => {
      const noSprayEntries = await NoSprayService.getList();
      const myNoSprayEntries = noSprayEntries.data.reduce(
        (acc, { attributes }) =>
          attributes.contractId === contractId ? [...acc, attributes] : acc,
        []
      );
      callback(myNoSprayEntries);
    };
    makeRequest();
  }

  requestSprayReminderEntries(callback) {
    const { contractId } = this;
    SprayRequestsService.index({
      contractId,
    }).then((res) => {
      callback(res);
    });
  }

  setOnPathDataPointChange(call) {
    this.onPathDataPointChange = call;
  }

  dig(object, prop, defaultValue = null) {
    return (object && object[prop]) || defaultValue;
  }
}
